import { Component, OnInit, Input } from '@angular/core';
import { IncidenceModel, TypeIncidence } from 'src/app/models/incidence.model';
import { ReturnService } from 'src/app/services/return.service';

@Component({
  selector: 'app-change-another-product',
  templateUrl: './change-another-product.component.html',
  styleUrls: ['./change-another-product.component.scss']
})
export class ChangeAnotherProductComponent implements OnInit {

  @Input() incidenceId: number;

  constructor(private returnService: ReturnService) { }

  ngOnInit() {

    const incidence = {} as IncidenceModel;
    incidence.incidenceId = this.incidenceId;
    incidence.type = TypeIncidence.CHANGE_ANOTHER_PRODUCT;
    incidence.status = 0

    console.log('incidence save', incidence);
    
    this.returnService.save(incidence).subscribe(
      data => {
        console.log('exit', data)
      },
      error => {
        console.error(error);
      }
    );
  }

}
